<template>
  <div class="container video-player-container" :class="`player-${id}`">
    <video controls crossorigin playsinline>
      <source :src="source" type="video/mp4" size="1080">

      <a :href="source" download>Скачать</a>
    </video>
  </div>
</template>
<script>
  import Plyr from 'plyr'

  export default {
    name: 'video-player',
    props: {
      source: {
        type: String,
        default: null,
      },
      id: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        player: null,
      }
    },
    mounted() {
      this.player = new Plyr(`.player-${this.id} video`, {
        autoplay: false,
        ratio: '16:9',
        hideControls: false,
        controls: [
          'play-large', // The large play button in the center
          'restart', // Restart playback
          'play', // Play/pause playback
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'volume', // Volume control
          'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          'fullscreen', // Toggle fullscreen
        ]
      });
    },
    beforeDestroy() {
      if (this.player) {
        this.player.destroy();
      }
    },
  }
</script>
<style lang="scss" scoped>
  @import "~plyr/dist/plyr.css";

  .video-player-container {
    height: 80%;
    width: 100%;
    padding: 0 70px;
  }

</style>
<style lang="scss">

  .plyr--video {
    width: 100%;
  }
  .plyr video {
    height: 100%;
  }
  .plyr__video-wrapper {
    height: 100% !important;
  }

</style>
